import { Box, Grid, Typography } from "@mui/material";
import styled from "styled-components";

import PhoneIcon from "../../../../assets/images/footer/phone.png";

export const SCCContainer = styled(Box)`
  && {
    width: 100%;
  }
`;

export const SCCContent = styled(Box)`
  && {
    width: 100%;
  }
`;

export const Title = styled(Typography)`
  && {
    color: #8a8a8a;
    font-size: 1rem;
    line-height: 26.5px;
    font-weight: 700;
    margin-bottom: 10px;
    position: relative;
    top: 5px;
    left: 5px;
  }
`;

export const SubTitle = styled(Typography)`
  && {
    color: #8a8a8a;
    font-size: 1rem;
    line-height: 26.5px;
    margin-bottom: 10px;
  }
`;

export const SCCIcon = styled.div`
  && {
    background: url(${PhoneIcon}) no-repeat center;
    background-size: 55%;
    width: 42px;
    height: 42px;
  }
`;

export const SCCItem = styled(Grid)`
  && {
    max-width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    @media screen and (max-width: 960px) {
      text-align: center;
      padding: 0 10px;
    }
  }
`;

export const SCCButton = styled.a`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    background-color: transparent;
    color: #ffffff;
    border-radius: 27px;
    width: 80%;
    margin: 0 auto 15px;
    border: 1px solid #ffffff;
    padding: 8px 16px;

    text-decoration: none;
    text-transform: none;
    box-shadow: none;
    cursor: pointer;

    @media screen and (max-width: 425px) {
      width: 100%;
    }
  }

  &&:hover {
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.08);
  }

  &&:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;